import StatementLinesReducer from "@bToC/Store/Data/StatementLines/StatementLinesReducer";
import { StatementLinesState } from "@bToC/Store/Data/StatementLines/StatementLinesState";
import StatementReducer from "@bToC/Store/Data/Statements/StatementReducer";
import { StatementDataState } from "@bToC/Store/Data/Statements/StatementState";
import CustomPagesReducer from "@bToC/Store/Pages/CustomPagesReducer";
import customPagesReducer, { CustomPagesReducers } from "@bToC/Store/Pages/CustomPagesReducer";
import CustomPagesState from "@bToC/Store/Pages/CustomPagesState";
import createTypedReducer, { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type CustomTypeState = Readonly<{
    services: Array<string>;
    solutions: Array<string>;
    manufacturer: string;
}>;

const initialServicesTypeState: CustomTypeState = { services: [], solutions: [], manufacturer: "" };

// Services Reducer----------------------------------------
const addServicesReducer = createTypedReducer(initialServicesTypeState, {
    "Custom/Traditional/AddServices": (
        state: CustomTypeState,
        action: { services: Array<string> },
    ): CustomTypeState => ({
        ...state,
        services: action.services,
    }),
});

// Solutions Reducer----------------------------------------
const addSolutionsReducer = createTypedReducer(initialServicesTypeState, {
    "Custom/Traditional/AddSolutions": (
        state: CustomTypeState,
        action: { solutions: Array<string> },
    ): CustomTypeState => ({
        ...state,
        solutions: action.solutions,
    }),
});

// Manufacturers Reducer-----------
const searchManufacturerReducer = createTypedReducer(initialServicesTypeState, {
    "Custom/SearchManufacturer": (state: CustomTypeState, action: { manufacturer: string }): CustomTypeState => ({
        ...state,
        manufacturer: action.manufacturer,
    }),
});

// Main Reducers -----------------------------------------------------

(reducers as any).addServicesReducer = addServicesReducer;
(reducers as any).searchManufacturerReducer = searchManufacturerReducer;
(reducers as any).addSolutionsReducer = addSolutionsReducer;
(reducers as any).statementReducer = StatementReducer;
(reducers as any).statementLinesReducer = StatementLinesReducer;
(reducers as any).customPagesReducer = CustomPagesReducer;

type Reducers = {
    addServicesReducer: typeof addServicesReducer;
    searchManufacturerReducer: typeof searchManufacturerReducer;
    addSolutionsReducer: typeof addSolutionsReducer;
    statementReducer: typeof StatementReducer;
    statementLinesReducer: typeof StatementLinesReducer;
    customPagesReducer: typeof customPagesReducer;
};

export type CustomState = {
    addServicesReducer: CustomTypeState;
    searchManufacturerReducer: CustomTypeState;
    addSolutionsReducer: CustomTypeState;
    statementReducer: StatementDataState;
    statementLinesReducer: StatementLinesState;
    customPagesReducer: CustomPagesState;
} & ApplicationState;
            
export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
